import React from "react";
import { TableCell, TableRow, Typography } from "@material-ui/core";

import { useListingTableStyles } from "../listing-table.styles";
import { ListingTableNoResultsProps } from "./listing-table-no-results.types";

export const ListingTableNoResults = (props: ListingTableNoResultsProps) => {
  const classes = useListingTableStyles();

  return (
    <TableRow>
      <TableCell className={classes.noResults} colSpan={Math.max(1, props.columns)}>
        <Typography variant="h6">{props.message ?? "No results"}</Typography>
      </TableCell>
    </TableRow>
  );
};
